package dev.bitspittle.droidconSf24.pages.sections.kobweb.silk

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun CssStyle8Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/silk/CssStyle8.md", mapOf())) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("cssstyle") }) {
                org.jetbrains.compose.web.dom.Text("CssStyle")
            }
            org.jetbrains.compose.web.dom.P {
                com.varabyte.kobweb.compose.dom.GenericTag("a", "href=\"https://opletter.github.io/css2kobweb/\"") {
                    com.varabyte.kobweb.silk.components.navigation.Link("https://opletter.github.io/css2kobweb/") {
                        org.jetbrains.compose.web.dom.Text("https://opletter.github.io/css2kobweb/")
                    }
                }
            }
            Video("css2kobweb.mp4", Modifier.size(75.percent).justifySelf(JustifySelf.Center))
        }
    }
}
